module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/9-bbb92be176b2e48fb3ffe84cb79dbd19.jpg";